export default "__VITE_ASSET__DKvP2OLX__"